import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

export default function SuccessDialog({
  open,
  onClose,
  ...props
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        You did it!
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          You have successfully assembled the fossil. You
          may now rotate the fossil to get a better look at
          it, or press the reset button to assemble it
          again.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus>
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  )
}
